<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Usuários
          </h4>
          <el-button icon="nc-icon nc-zoom-split "
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="margin-left:auto"
              ></el-button>
          
        </div>
        <router-link to="/app/user" class="pesquisa" v-if="permission('create_user') || showMatriz">
            <l-button wide type="primary" style="position: right; " round >
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Username</label>
                <el-autocomplete
                  class="select-default col-sm-12"
                  v-model="usernameFilter"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="Comece a digitar para pesquisar"
                  @select="handleSelect"
                ></el-autocomplete>
            </div>
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Nome</label>
                <el-autocomplete
                  class="select-default col-sm-12"
                  v-model="first_nameFilter"
                  :fetch-suggestions="querySearchAsync2"
                  placeholder="Comece a digitar para pesquisar"
                  @select="handleSelect2"
                ></el-autocomplete>
            </div>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
            <el-table-column label="Apelido" property="username" sortable="custom" />
            <el-table-column label="Nome" property="fullName" />
            <el-table-column label="Data" property="last_login" sortable="custom"/>
            <el-table-column label="Ações" width="90">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                    <a
                    class="btn btn-warning btn-link btn-xs"
                    v-if="permission('edit_user')"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                  class="btn btn-danger btn-link btn-xs"
                  v-if="permission('delete_user')"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Autocomplete, 
  Loading,
  Tooltip
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Autocomplete.name]: Autocomplete,
    [Tooltip.name]: Tooltip
  },
    data () {
      return {
        filtro: false,
        produto: [],
        tipo: [],
        prateleira: [],
        vendMachine: [],
        date_init: [],
        users: [],
        products: [],
        machines: [],
        usernameFilter : '',
        first_nameFilter: '',
        showTable: true,
        usersAPI: [],
        totalResults: 30,
        pesquisa: '',
        page: 1,
        pageSize: 10,
        order: false,
        loading: true,
        btnLoading: false,
        sord: '',
        companyList: []
      }
    },
    mounted () {
    this.getData()
    this.getListCompany()
    },
  computed: {
    tableData() {
      let users = this.$store.state.users.users
      let dateConverted = users.map(v => {
        let fullName

        fullName = v.first_name + ' ' + v.last_name
        const d = new Date(v.last_login);
        const last_login = d.toLocaleString("pt-BR");
        return { ...v, last_login, fullName };
      });
      return dateConverted;
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    productsName() {
      return this.$store.state.products.products;
    },
  },
  created() {
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === 'vm') {
        x.prop = 'vm__location'
      }
      if (x.prop === 'product') {
        x.prop = 'product__name'
      }
      this.sord = sinal + x.prop
      this.getData()
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      this.getData()
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/user/${row.id}`);
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = "Usuário";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("users/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    filtragem () {
      this.users = this.usersAPI
      this.pesquisa = ''

      if (this.usernameFilter) {
        this.pesquisa = this.pesquisa + '&username=' + this.usernameFilter
      }
      if (this.first_nameFilter) {
        this.pesquisa = this.pesquisa + "&first_name=" + this.first_nameFilter
      }
      this.getData()
      this.filtro = false;
    },
    clearFiltro() {
      this.usernameFilter = ''
      this.first_nameFilter = ''
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.getData();
    },
    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("users/listSort", {sort: '?username__icontains=' + queryString}).then(data => {
        var x = data.results.map(v => {
          let value, link
          if (v.username) {
            value = v.username
          }
          link = value
          return {...v, value, link}
          
        })
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var links
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },
    querySearchAsync2(queryString, cb) {
      var y
      this.$store.dispatch("users/listSort", {sort: '?first_name__icontains=' + queryString}).then(data => {
        var x = data.results.map(v => {
          let value, link
          if (v.first_name) {
            value = v.first_name
          }
          link = value
          return {...v, value, link}
          
        })
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.usernameFilter = item.username
      console.log('selec', item);
    },
    handleSelect2(item) {
      this.first_nameFilter = item.first_name
      console.log('selec', item);
    },
    redux(x) {
      // var seenNumber = {};

      // var fil = x.filter(function(
      //   currentObject
      // ) {
      //   if (currentObject.status in seenNumber) {
      //     return false;
      //   } else {
      //     seenNumber[currentObject.status] = true;
      //     return true;
      //   }
      // });
      // return fil;
      return x
    },
    report() {
      if (this.totalResults > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResults + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        this.pesquisa = this.pesquisa.replace('&','?')
        this.$store.dispatch('general/excelMovement', {search: this.pesquisa}).then(data => {
          this.btnLoading = data
        })
      }
    },
    permission(permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(
        el => {
          if (el == permissao) {
            return true;
          }
        }
      );
      if (x.length > 0) {
        return true;
      }
    },
    getData () {
      this.loading = true
      this.$store.dispatch("users/listSort", {sort: '?page_size=' + this.pageSize
        + '&page=' + this.page + '&ordering=' + this.sord + this.pesquisa}).then(resp => {
        this.totalResults = this.$store.state.users.page.count
        this.users = resp
        this.usersAPI = resp
        this.loading = false
        console.log('total', this.totalResults)
        console.log('store', this.$store.state)
      }).catch(err => console.log(err));
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
